// @core/api/endpoints/notifications/list_notifications.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListNotificationsResponse,
} from '../../../types/notifications';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/notifications';

/**
 * List notifications with filters
 * Returns a paginated list of notifications matching the specified filter criteria. Supports filtering by status, type, recipient, and date range.
 */
export async function ListNotifications(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListNotificationsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/notifications`;
  const requestOptions = options;
  return client.get<ListNotificationsResponse>(requestPath, { ...requestOptions, params });
}
